import type {
  CardBodyProps as ChakraCardBodyProps,
  SystemStyleObject,
} from '@chakra-ui/react';
import { CardBody as ChakraCardBody, useCardStyles } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type CardBodyProps = OmitChakraProps<ChakraCardBodyProps> & {
  __orbitStyleConfig?: SystemStyleObject;
};

export const CardBody = withChakraAs<CardBodyProps, 'div'>((props) => {
  const styles = useCardStyles();
  return (
    <ChakraCardBody
      {...props}
      __css={{ ...styles.body, ...props.__orbitStyleConfig }}
    />
  );
});
